(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password-production"]) return;
  try {
    
  (function () {
    function start(root) {
      if (root.dataset.ppInit) return;
      root.dataset.ppInit = '1';
      const target = root.getAttribute('data-countdown-target');
      const t = target ? new Date(target).getTime() : NaN;
      if (isNaN(t)) { root.style.display = 'none'; return; }
      const els = {
        days: root.querySelector('[data-unit="days"]'),
        hours: root.querySelector('[data-unit="hours"]'),
        minutes: root.querySelector('[data-unit="minutes"]'),
        seconds: root.querySelector('[data-unit="seconds"]')
      };
      let iv;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        const diff = t - Date.now();
        if (diff <= 0) {
          els.days.textContent = els.hours.textContent = els.minutes.textContent = els.seconds.textContent = '00';
          if (iv) clearInterval(iv);
          return;
        }
        const s = Math.floor(diff / 1000);
        els.days.textContent = pad(Math.floor(s / 86400));
        els.hours.textContent = pad(Math.floor((s % 86400) / 3600));
        els.minutes.textContent = pad(Math.floor((s % 3600) / 60));
        els.seconds.textContent = pad(s % 60);
      }
      tick();
      iv = setInterval(tick, 1000);
    }
    function init() {
      const roots = document.querySelectorAll('[data-pp-countdown-root]');
      for (let i = 0; i < roots.length; i++) start(roots[i]);
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();
})();
